"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useMaasAccount = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useMaasAccounts = _interopRequireDefault(require("./hooks/useMaasAccounts"));

var _Alert = _interopRequireDefault(require("./Alert"));

var _router = require("./helpers/router");

var _PageError = _interopRequireDefault(require("./PageError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var MaasContext = /*#__PURE__*/_react["default"].createContext({});

var useMaasAccount = function useMaasAccount() {
  return _react["default"].useContext(MaasContext);
};

exports.useMaasAccount = useMaasAccount;

var MaasAccount = function MaasAccount(_ref) {
  var children = _ref.children,
      config = _ref.config,
      LoadingComponent = _ref.LoadingComponent,
      CustomPageError = _ref.PageError;
  if (!config.keycloakToken) throw Error('keycloakToken is required');

  var _maasAccount = (0, _useMaasAccounts["default"])({
    config: config
  }),
      user = _maasAccount.user,
      sellers = _maasAccount.sellers,
      sellerPermissions = _maasAccount.sellerPermissions,
      currentServices = _maasAccount.currentServices,
      currentSeller = _maasAccount.currentSeller,
      setCurrentSeller = _maasAccount.setCurrentSeller,
      onSellerChanged = _maasAccount.onSellerChanged,
      loading = _maasAccount.loading,
      error = _maasAccount.error,
      setError = _maasAccount.setError;

  var verifySellerIsDifferent = (0, _react.useCallback)(function () {
    var _sellers$find, _sellers$;

    // verifica se o seller esta no localstorage e utiliza ele se existir
    var tenantIdSeller = sessionStorage.getItem('maas-tenantId') || ((_sellers$find = sellers.find(function (seller) {
      return seller.current;
    })) === null || _sellers$find === void 0 ? void 0 : _sellers$find.tenantId) || (sellers === null || sellers === void 0 ? void 0 : (_sellers$ = sellers[0]) === null || _sellers$ === void 0 ? void 0 : _sellers$.tenantId); // verifica se existe tenantId via config props ou buscar no query params

    var tenantIdByUrl = config.tenantId || (0, _router.getTenantIdFromUrl)(); // se existir via props ou query params da prioridade

    setCurrentSeller(tenantIdByUrl || tenantIdSeller);
  }, [config.tenantId, sellers, setCurrentSeller]);
  (0, _react.useEffect)(function () {
    if (!loading) verifySellerIsDifferent();
  }, [loading]);
  if (loading || currentSeller === undefined) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, LoadingComponent);

  if (!currentSeller) {
    return CustomPageError || /*#__PURE__*/_react["default"].createElement(_PageError["default"], null);
  }

  var initialValues = {
    user: user,
    currentSeller: currentSeller,
    currentServices: currentServices,
    sellerPermissions: sellerPermissions,
    changeSeller: setCurrentSeller,
    onSellerChanged: onSellerChanged,
    sellers: sellers,
    error: error
  };
  return /*#__PURE__*/_react["default"].createElement(MaasContext.Provider, {
    value: initialValues
  }, /*#__PURE__*/_react["default"].createElement(MaasContext.Consumer, null, function (values) {
    if (values.error.error) {
      return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        message: error.message,
        onDismiss: function onDismiss() {
          return setError({
            error: false,
            message: ''
          });
        }
      });
    }
  }), children);
};

var _default = MaasAccount;
exports["default"] = _default;